import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { MenuItem } from "../../types/menuItem.type";
// import { MenuItem } from "../../types/menu.type";
import { RootState } from "../../types/state.type";


export default /*#__PURE__*/_defineComponent({
  props: {
  items: {
    type: Array as () => MenuItem[],
    default: () => [],
  },
},
  setup(__props) {

const store = useStore<RootState>();
const route = useRoute();
const router = useRouter();
const toggle = "ui/sidebarToggle";

// - props


// - computed
const onRoutes = computed(() => route.path);
const isMobile = computed(() => store.state.ui.window?.mobile);
const sidebarOpen = computed(() => store.state.ui.sidebarOpen);

console.log("onRoutes.value", onRoutes.value);
// - if is main menus, force open
if (sidebarOpen.value === false) {
  switch (onRoutes.value) {
    case "/support":
      store.commit(toggle, force);
      break;
    case "/stations":
      store.commit(toggle, force);
      break;
    case "/admin":
      store.commit(toggle, force);
      break;
    case "/process-tracking":
      store.commit(toggle, force);
      break;
    case "/sace":
      store.commit(toggle, force);
      break;
    case "/issue-monitoring":
      store.commit(toggle, force);
      break;
  }
}

// - methods

/**
 * handle select
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const handleSelect = (key: string, _keyPath: string[]) => {
  router.push(key);

  // - if is mobile, force close
  if (isMobile.value) {
    sidebarToggle(false);
  }

  console.log("key", key);
  // - when select home, force open
  switch (key) {
    case "/support":
      sidebarToggle(true);
      break;
    case "/stations":
      sidebarToggle(true);
      break;
    case "/admin":
      sidebarToggle(true);
      break;
    case "/process-tracking":
      sidebarToggle(true);
      break;
    case "/sace":
      sidebarToggle(true);
      break;
    case "/issue-monitoring":
      sidebarToggle(true);
      break;
  }
};

/**
 * sidebar Toggle
 */
const sidebarToggle = (force: undefined | boolean = undefined) => {
  store.commit(toggle, force);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
function force(arg0: string, force: any) {
  throw new Error("Function not implemented.");
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_menu, {
      class: "menu",
      "default-active": _unref(onRoutes),
      collapse: "",
      "unique-opened": "",
      onSelect: handleSelect
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.subs)
              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                  index: item.index,
                  key: item.index
                }, {
                  title: _withCtx(() => [
                    _createElementVNode("em", {
                      class: _normalizeClass(item.icon)
                    }, null, 2),
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.title)), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.subs, (subItem) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (subItem.subs)
                          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                              index: subItem.index,
                              key: `${subItem.index}`
                            }, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(subItem.title), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subItem.subs, (threeItem, i) => {
                                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                                    key: i,
                                    index: threeItem.index
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t(threeItem.title)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                          : (_openBlock(), _createBlock(_component_el_menu_item, {
                              index: subItem.index,
                              key: `${subItem.index}-else`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(subItem.title)), 1)
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                      ], 64))
                    }), 256))
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (_openBlock(), _createBlock(_component_el_menu_item, {
                  index: item.index,
                  key: item.index,
                  disabled: item.disabled
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(item.title)), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("em", {
                      class: _normalizeClass(item.icon)
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["index", "disabled"]))
          ], 64))
        }), 256))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})